import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import MasterLayout from "./layouts/MasterLayout";
import About from "./pages/About";
import Contact from "./pages/Contact";
import VigilMechanism from "./pages/VigilMechanism";
import Grievance from "./pages/Grievance";
import Network from "./pages/Network";
import Products from "./pages/Products";
import Methodology from "./pages/Methodology";
import CSR from "./pages/Csr";
import Reports from "./pages/Reports";
import Policies from "./pages/Policies";
import SecurityTips from "./pages/SecurityTips";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import CashlessPayments from "./pages/CashlessPayments";
import PublicCautionNotice from "./pages/PublicCautionNotice";
import ScrollToTop from "./components/ScrollToTop";
import Csr_doc from "./pages/Csr_doc";
const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MasterLayout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/products" element={<Products />} />
          <Route path="/vigil-mechanism" element={<VigilMechanism />} />
          <Route path="/grievance" element={<Grievance />} />
          <Route path="/methodology" element={<Methodology />} />
          <Route path="/network" element={<Network />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/policies" element={<Policies />} />
          <Route path="/csr" element={<CSR />} />
          <Route path="/security-tips" element={<SecurityTips />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/cashless-payments" element={<CashlessPayments />} />
          <Route path="/csr-document" element={<Csr_doc/>} />
          <Route
            path="/public-caution-notice"
            element={<PublicCautionNotice />}
          />
          <Route path="*" element={<h1>404 - Page Not Found</h1>} />
        </Route>
      </Routes>
    </>
  );
};

export default AppRoutes;
